<template lang="pug">
   fragment
        line-chart.chart
        div.xAxisMonth(v-if="period === 'month'") {{ currentMonth }}
</template>

<script>
    import dayjs from 'dayjs';
    import LineChart from './LineChart';
    import { mapGetters } from 'vuex';

    export default {
        components: {
            LineChart
        },
        computed: {
            ...mapGetters('statistics', ['period']),
            currentMonth() {
                return dayjs().format('MMMM');
            }
        }
    };
</script>

<style lang="stylus" scoped>
    @import '../../../../assets/style/_variables.styl'
    @import '../../../../assets/style/_mixins.styl'

    .chart
        height: 400px

    .before
        color: $theme.action

    .after
        color: $theme.white

    .xAxisMonth
        text-transform: uppercase
        text-align: center
        font-size: 13px

    .legend
        text-align: right

        & > div
            display: inline-block
            margin-right: 10px

    @media screen and (max-width: $grid-breakpoints.sm - 1)
        .chart
            height: 300px
</style>
